module.exports = __webpack_public_path__ + "static/media/gg_chevron-double-left.40d7f3dd.svg";